import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";

/**
 * GET /student-profile/options — the degree catalogue (with the branches under
 * each degree), the document sections, work modes and suggested domains. One
 * read per page load, shared by every component on the page.
 *
 * Fails soft: with no answer the form still renders, with a free-typed degree.
 */
let cache = null;
let inflight = null;

export const EMPTY_OPTIONS = {
  degrees: [],
  documentSections: [],
  documentAccept: ".pdf,.jpg,.jpeg,.png,.webp",
  imageAccept: ".jpg,.jpeg,.png,.webp",
  documentMaxMb: 5,
  workModes: [],
  suggestedDomains: [],
};

export function loadProfileOptions() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = apiClient.get("/student-profile/options")
      .then(({ data }) => { cache = { ...EMPTY_OPTIONS, ...data }; return cache; })
      .catch(() => EMPTY_OPTIONS)
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** For tests and for a signed-out → signed-in change. */
export const resetProfileOptions = () => { cache = null; };

export default function useProfileOptions() {
  const [options, setOptions] = useState(cache || EMPTY_OPTIONS);
  const [loading, setLoading] = useState(!cache);
  useEffect(() => {
    let live = true;
    loadProfileOptions().then((o) => { if (live) { setOptions(o); setLoading(false); } });
    return () => { live = false; };
  }, []);
  return { options, loading };
}
